import { MeasurementName } from 'core/constant/MeasurementName';
import { sendMeasurement } from 'core/messaging/measurement/measurement';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { SearchErrorCode } from 'gql/autogen/SearchErrorCode';
import { SearchSubErrorCode } from 'gql/autogen/SearchSubErrorCode';

export const countTotal = (operationName: string, pageTypeId: ActivitiesPageTypes) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlTotal, pageTypeId);
    sendMeasurement(measurement, pageTypeId);
};

export const countRetry = (operationName: string, pageTypeId: ActivitiesPageTypes, currentRetry: number) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlRetry, pageTypeId);
    measurement.tags.currentRetry = currentRetry.toString();

    sendMeasurement(measurement, pageTypeId);
};

export const countGraphQLError = (operationName: string, pageTypeId: ActivitiesPageTypes, status: number, errorCode?: string, subErrorCode?: string) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlError, pageTypeId);
    measurement.tags.status = status ? status.toString() : '';
    measurement.tags.errorcode = errorCode || SearchErrorCode.EMPTY_ERROR_CODE;
    measurement.tags.subErrorCode = subErrorCode || SearchSubErrorCode.EMPTY_SUB_ERROR_CODE;

    sendMeasurement(measurement, pageTypeId);
};

export const countGraphQLIncomplete = (operationName: string, pageTypeId: ActivitiesPageTypes) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlIncomplete, pageTypeId);
    sendMeasurement(measurement, pageTypeId);
};

export const countNetworkError = (operationName: string, pageTypeId: ActivitiesPageTypes) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlNetworkError, pageTypeId);
    sendMeasurement(measurement, pageTypeId);
};

export const measureRoundTripTime = (operationName: string, roundTripTime: number, pageTypeId: ActivitiesPageTypes) => {
    const measurement = buildMeasurement(operationName, MeasurementName.GqlRtt, pageTypeId, '', roundTripTime, true);
    sendMeasurement(measurement, pageTypeId);
};
